import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Link } from '@mui/material';
import { resetPassword } from '../../services/authService';
import { extractErrorMessage } from '../../utils/errors';
import { AuthLayout, FormError, PasswordField, SubmitButton, authLinkSx } from './AuthLayout';
import useUrlToken from './useUrlToken';

const LINK_INVALID_MESSAGE = 'Ссылка недействительна или устарела';

export default function ResetPasswordPage() {
  const token = useUrlToken();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [linkInvalid, setLinkInvalid] = useState(!token);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting || linkInvalid) return;
    if (password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return;
    }
    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setError('');
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      navigate('/login', { replace: true, state: { message: 'Пароль изменён. Войдите с новым паролем' } });
    } catch (err) {
      const message = extractErrorMessage(err);
      // Токен недействителен — другой пароль не поможет, нужна новая ссылка
      if (message === LINK_INVALID_MESSAGE) setLinkInvalid(true);
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Новый пароль" onSubmit={handleSubmit}>
      {linkInvalid ? (
        <>
          <FormError>{error || LINK_INVALID_MESSAGE}</FormError>
          <Box sx={{ textAlign: 'center', fontSize: '14px' }}>
            <Link component={RouterLink} to="/forgot-password" sx={authLinkSx}>
              Запросить новую ссылку
            </Link>
          </Box>
        </>
      ) : (
        <>
          <PasswordField
            id="reset-password"
            label="Новый пароль"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="new-password"
            hint="Минимум 8 символов"
            required
          />
          <PasswordField
            id="reset-password-confirm"
            label="Повторите пароль"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
            required
          />
          <FormError>{error}</FormError>
          <SubmitButton submitting={submitting}>Сохранить пароль</SubmitButton>
        </>
      )}
      <Box sx={{ textAlign: 'center', fontSize: '14px' }}>
        <Link component={RouterLink} to="/login" sx={authLinkSx}>
          Вернуться ко входу
        </Link>
      </Box>
    </AuthLayout>
  );
}
